// 将formItemKey转换为list
// a.b.c => [a, b, c]
// a[0][1]b.c => [a, 0, 1, b, c]
// 注意
// a[0].b => [a, 0, b]
// a.[0].b.c => [a, 0, b, c]
type NamePath = string | number | (string | number)[];

export function formItemKeyToList(formItemKey: NamePath): (string | number)[] {
  // console.log(formItemKey,'表单枚举');
  if (Array.isArray(formItemKey)) {
    return formItemKey;
  }
  if (typeof formItemKey === 'number') {
    return [formItemKey];
  }

  // 初始化一个空列表
  let list = [];
  // 初始化一个临时字符串
  let temp = '';
  // 初始化一个标志，表示是否在括号内
  let isBracket = false;
  // 初始化一个标志，表示是否在引号内
  let isQuote = false;
  // 遍历formItemKey的每一个字符
  for (let i = 0; i < formItemKey?.length; i++) {
    // 获取当前字符
    const char = formItemKey?.[i];
    // 如果当前字符是左括号
    if (char === '[') {
      // 设置标志为真
      isBracket = true;
      // 如果临时字符串不为空
      if (temp) {
        // 将临时字符串添加到列表中
        list.push(temp);
        // 清空临时字符串
        temp = '';
      }
      // 如果当前字符是右括号
    } else if (char === ']') {
      isBracket = false;
      // 将临时字符串添加到列表中
      try {
        // 将临时字符串解析为JSON,获得数字
        temp = JSON.parse(temp);
      } catch (err) {
        console.error('formItemKeyToList', err);
      }
      list.push(temp);
      // 清空临时字符串
      temp = '';
      // 如果当前字符是点，并且不在引号内
    } else if (char === '.' && !isQuote) {
      // 如果在括号内
      if (isBracket) {
        // 将点添加到临时字符串中
        temp += char;
        // 如果不在括号内
      } else {
        // 将临时字符串添加到列表中
        list.push(temp);
        // 清空临时字符串
        temp = '';
      }
      // 如果当前字符是引号
    } else if (char === '"' || char === "'") {
      // 切换引号标志
      isQuote = !isQuote;
      // 如果当前字符是其他字符
    } else {
      // 将当前字符添加到临时字符串中
      temp += char;
    }
  }
  // 如果临时字符串不为空
  if (temp) {
    // 将临时字符串添加到列表中
    list.push(temp);
  }
  // 返回列表，过滤掉空字符串
  return list.filter((n) => n !== '') as (string | number)[];
}

// 默认校验规则
export const DefaultRequiredRuleMap = {
  currencyType: {
    validator: function (rule, value) {
      return new Promise((resolve, reject) => {
        if (['', undefined].includes(value?.value) || !value?.currency) {
          const message = !value?.currency ? '请选择币种' : '请输入金额';
          reject(new Error(message));
        } else {
          resolve(true);
        }
      });
    },
    message: undefined,
  },
  projectCode: {
    validator: function (rule, value) {
      return new Promise((resolve, reject) => {
        if (!value?.project_number) {
          reject(new Error('请输入项目编号'));
        } else {
          resolve(true);
        }
      });
    },
    message: undefined,
  },
  upload: {
    validator: function (rule, value) {
      const label = typeof rule?.label === 'string' ? rule?.label : '';
      const defaultMessage = label ? `${label}  不能为空` : '请上传文件';
      return new Promise((resolve, reject) => {
        if (value?.some((n) => n.status === 'uploading')) {
          reject(new Error('上传中'));
          return;
        }
        if (!value?.filter((n) => !!n.id)?.length) {
          reject(new Error(defaultMessage));
          return;
        }
        resolve(true);
      });
    },
    message: undefined,
  },
};
